// Buffs and debuffs: timed effects on a player, shown beside the character panel and on the character for everyone.
// Kinds are a wire/save enum: append only, never reuse.
import { GameConstants } from '../constants';

export enum BuffKind {
  /** After rekindling at your corpse: nothing can hurt you for a moment. */
  Rekindled = 0,
  /** Set alight (a campfire): damage over time. */
  Burning = 1,
}

export interface BuffDefinition {
  kind: BuffKind; name: string; description: string;
  /** A debuff harms (shown with a red border); a buff helps. */
  debuff: boolean;
  /** How long it lasts from when it was last applied, in 30 Hz ticks. */
  durationTicks: number;
  /** Damage each whole second it lasts (0 = none). */
  damagePerSecond: number;
  /** No damage reaches the player while it lasts. */
  immune: boolean;
  /** What killed them, if its damage does ("You were slain by fire"). */
  cause: string;
}

const seconds = (s: number) => s * GameConstants.tickRate;

export const Buffs: Record<BuffKind, BuffDefinition> = {
  [BuffKind.Rekindled]: { kind: BuffKind.Rekindled, name: 'Rekindled', description: 'Back from the grave: nothing can harm you.',
    debuff: false, durationTicks: seconds(5), damagePerSecond: 0, immune: true, cause: '' },
  [BuffKind.Burning]: { kind: BuffKind.Burning, name: 'Burning', description: 'On fire: 1 damage each second.',
    debuff: true, durationTicks: seconds(5), damagePerSecond: 1, immune: false, cause: 'fire' },
};

export const buffDefinition = (kind: number): BuffDefinition | undefined => Buffs[kind as BuffKind];

/** How close the player's collision box must come to an igniting object's tile to catch fire, in pixels. */
export const igniteReachPixels = 2;

/** How long a ghost holds E at its corpse to rekindle, in ticks; and how close it must stand (pixels from the corpse). */
export const Rekindle = { durationTicks: seconds(1.5), reachPixels: 20 };

/** A player's state through death: alive, dead where they fell (awaiting release), or a ghost running back. */
export enum LifeState { Alive = 0, Dead = 1, Ghost = 2 }
